import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const SNIPPETS_SNIPPET_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/snippets',
        iconClass: 'fas fa-file-alt',
        name: '::Menu:Snippets',
        layout: eLayoutType.application,
        requiredPolicy: 'Mandir.Snippets',
      },
    ]);
  };
}
